import { ReactComponent as CheckIcon } from './check.svg';

export default CheckIcon;
